import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { Desktop, Mobile } from '../../App';
import {
  LP,
  MLP,
  NameInitials,
  NumberRound,
  USDT,
  dateDifferenceInDaysFromToday,
  formatUSD
} from '../../helpers/helperFunctions';

import { useWindowWide } from '../../helpers/wideScreen';
import {
  CaptionText,
  H1,
  H2,
  H3,
  H4,
  P1,
  P2,
  P3
} from '../../styles/FontStyles';
import {
  Box,
  // Button,
  Flexed,
  ProfileImage,
  ProfileImagePlaceholder,
  ProfilePicture,
  SectionSeparator
} from '../../styles/GlobalComponents';
import { colors } from '../../styles/GlobalStyles';
import {
  Icon,
  IconCashBackBonus,
  IconPlus,
  IconPortfolioDiamond
} from '../../styles/Icons';
import {
  Flex,
  FlexCenter,
  Responsive,
  SectionSeparatorDark
} from '../../styles/stylesStyled';
import { Username } from './DashboardStyled';

import MavieLogo from '../../assets/icons/backOffice/mavieGoldBlue.svg';

import moment from 'moment';
import Countdown from 'react-countdown';
import ReactTooltip from 'react-tooltip';

import { useAppSelector } from '../../app/hooks';
import {
  CASHBACK_BONUS,
  EARNINGS,
  RANKING
  // SETTINGS_VIRTUAL_OFFICE
} from '../../routes/routes';
import { Office, Trophy } from '../../styles/svg';
import { User } from '../../types/loginTypes';
import { DashboardInformation } from './Dashboard.types';

interface EarningsComponentProps {
  user: User;
  backOffice: DashboardInformation | null;
}

export const EarningsComponent = ({
  user,
  backOffice
}: EarningsComponentProps) => {
  const { t } = useTranslation('dashboard');
  const history = useHistory();
  const { dashboardInfo } = useAppSelector((state) => state.dashboard);
  const wide = useWindowWide(800);
  const { isCanadaRestrictedUser } = useAppSelector(
    (state) => state.auth.userInfo
  );

  const bonusesIcons = [
    // {
    //   id: 'office-tooltip',
    //   icon: Office,
    //   linkTo: '',
    //   tip: t('backoffice'),
    //   disabled: true
    // },
    {
      id: 'ranking-tooltip',
      icon: Trophy,
      linkTo: RANKING,
      tip: t('ranking'),
      disabled: false
    },

    {
      id: 'cashback-tooltip',
      icon: IconCashBackBonus,
      linkTo: CASHBACK_BONUS,
      tip: t('fast_start_bonus'),
      disabled: false
    }
  ];

  const HubInfo = () => {
    return (
      <Flexed column justifyCenter>
        {/* <Flexed
          center
          mb='20'
          style={{ cursor: 'pointer' }}
          onClick={() => history.push('/backoffice/settings/virtual-office')}>
          <Icon color={colors.secondary100} mr='15' fill>
            <Office />
          </Icon>
          <Flexed column>
            <P2 bold> {t('backoffice_subscription')} </P2>

            <Flexed between>
              <P3 color={colors.neutral700}>
                {t('days_left')}:{' '}
                {`${dateDifferenceInDaysFromToday(
                  dashboardInfo?.user?.currentVirtualOfficeLicence?.dateEnd
                )}`}
              </P3>

              <Icon color={colors.secondary100} fill>
                <IconPlus size={'14'} />
              </Icon>
            </Flexed>
          </Flexed>
        </Flexed> */}
        <Flexed
          center
          mb='20'
          style={{ cursor: 'pointer' }}
          onClick={() => history.push('/backoffice/ranking')}>
          <Icon color={colors.secondary100} ml='-15' fill>
            <IconPortfolioDiamond />
          </Icon>
          <Flexed column>
            <P2 bold>
              {t('current_rank')}: {dashboardInfo?.user?.lifetimeRank}
            </P2>

            <Flexed between>
              <P3 color={colors.neutral700}>
                {t('qualified_rank')}: {dashboardInfo?.user?.qualifiedRank}
              </P3>
            </Flexed>
          </Flexed>
        </Flexed>
        {!isCanadaRestrictedUser && (
          <Flexed
            center
            style={{ cursor: 'pointer' }}
            onClick={() => history.push('/backoffice/cashback-bonus')}>
            <Icon color={colors.secondary100} mr='15' fill>
              <IconCashBackBonus />
            </Icon>

            <Flexed column>
              <P2 bold>{t('fast_start_bonus')}</P2>

              <Flexed between>
                <P3 color={colors.neutral700}>
                  {dashboardInfo?.user?.fastStartBonus?.isClaimed
                    ? t('claimed')
                    : t('not_claimed')}
                </P3>
              </Flexed>
            </Flexed>
          </Flexed>
        )}
      </Flexed>
    );
  };

  const CountdownComponent = () => {
    // const start = moment(new Date());
    const endOfTheWeek = moment().utc().endOf('isoWeek');

    // const duration = moment.duration(endOfTheWeek.diff(start));
    let now = new Date();
    now.setDate(now.getDate() + 1);
    now.setHours(13);
    now.setSeconds(0);
    now.setMinutes(0);

    const timestamp = Number(endOfTheWeek.format('x'));

    return (
      <Countdown
        date={timestamp}
        renderer={({ days, hours, minutes }) => (
          <P3 color={colors.neutral500} semiBold>
            {t('cap_week_ends', { days, hours, minutes })}
          </P3>
        )}
      />
    );
  };

  return (
    <>
      <Responsive between end='true' startSM mb='20' mbSM='16'>
        {/* <IconTitleStyled style={{ margin: 0 }}>
          {t('my_mavie_overview')}
        </IconTitleStyled> */}
        <CountdownComponent />
      </Responsive>
      <Box p='40px'>
        <FlexCenter>
          <div style={{ position: 'relative', marginRight: wide ? 80 : 20 }}>
            <ProfilePicture size={wide ? '280px' : '64px'}>
              {user?.profileImageUrl ? (
                <ProfileImage src={user?.profileImageUrl} alt='Upload' />
              ) : (
                <ProfileImagePlaceholder
                  size={window.innerWidth > 800 ? '280px' : '64px'}
                  font={window.innerWidth > 800 ? '96px' : '20px'}>
                  {NameInitials()}
                </ProfileImagePlaceholder>
              )}
            </ProfilePicture>
            <Desktop style={{ width: '100%' }}>
              <Username>
                <P1 color={colors.secondary100} bold>
                  {t('earnings.hi')} {user?.name},
                </P1>
                <H2 color={colors.neutral900}>
                  {t('earnings.sky_is_the_limit')}
                </H2>
              </Username>
            </Desktop>
          </div>
          <div style={{ width: '100%' }}>
            <Mobile>
              <P2 color={colors.neutral900} bold>
                {' '}
                {t('earnings.hi')} {user?.name},
              </P2>
              <H3 color={colors.neutral900}>
                {t('earnings.sky_is_the_limit')}
              </H3>
            </Mobile>
            <Desktop>
              <Flexed between>
                <div>
                  <Flexed between mb='12'>
                    <Flex style={{ flexWrap: 'wrap' }}>
                      <div style={{ marginRight: 50 }}>
                        <CaptionText color={colors.neutral500}>
                          {t('earnings.total_earnings')}
                        </CaptionText>
                        <H1 bold mb='4'>
                          {backOffice &&
                            formatUSD(
                              NumberRound(backOffice?.user?.totalEarnings)
                            )}{' '}
                          {USDT}
                        </H1>
                        {backOffice && (
                          <P3 flex color={colors.neutral500}>
                            <P3 color={colors.secondary100} mr='5' bold>
                              {backOffice?.user?.currentWeekEarnings > -1 &&
                                '+'}
                              {formatUSD(
                                NumberRound(
                                  backOffice?.user?.currentWeekEarnings
                                )
                              )}{' '}
                              {USDT}{' '}
                            </P3>
                            {t('earnings.this_week')}
                          </P3>
                        )}
                      </div>
                    </Flex>
                  </Flexed>

                  <Flexed column onClick={() => history.push(EARNINGS)} mb='4'>
                    <CaptionText pointer color={colors.neutral500}>
                      {USDT} {t('earnings.balance')}
                    </CaptionText>
                    <H2 pointer>
                      {formatUSD(
                        backOffice?.user?.userTickets?.availableRewardPoints
                      )}{' '}
                      {USDT}
                    </H2>
                  </Flexed>

                  <Flexed column onClick={() => history.push(EARNINGS)} mb='4'>
                    <CaptionText pointer color={colors.neutral500}>
                      {t('earnings.club_balance')}
                    </CaptionText>
                    <H2 pointer>
                      {formatUSD(backOffice?.user?.userTickets?.shoppingPoints)}{' '}
                      {USDT}
                    </H2>
                  </Flexed>
                  {backOffice?.user?.userTickets?.loyaltyPoints &&
                  backOffice?.user?.userTickets?.loyaltyPoints > 0 ? (
                    <Flexed column onClick={() => history.push(EARNINGS)}>
                      <CaptionText pointer color={colors.neutral500}>
                        {t('earnings.loyalty_points')}
                      </CaptionText>
                      <H2 pointer>
                        {formatUSD(
                          backOffice?.user?.userTickets?.loyaltyPoints
                        )}{' '}
                        {LP}
                      </H2>
                    </Flexed>
                  ) : null}

                  {backOffice?.user?.userTickets?.myLifePoints &&
                  backOffice?.user?.userTickets?.myLifePoints > 0 ? (
                    <Flexed column onClick={() => history.push(EARNINGS)}>
                      <CaptionText pointer color={colors.neutral500}>
                        FinUP balance
                      </CaptionText>
                      <H2 pointer>
                        {formatUSD(backOffice?.user?.userTickets?.myLifePoints)}{' '}
                        {USDT}
                      </H2>
                    </Flexed>
                  ) : null}
                </div>
                <HubInfo />
              </Flexed>
            </Desktop>
          </div>
        </FlexCenter>
        <div>
          <Mobile>
            <SectionSeparator margin='20px 0' />
            <Flex style={{ flexWrap: 'wrap' }}>
              <div style={{ marginRight: 50 }}>
                <CaptionText color={colors.neutral500}>
                  {t('earnings.total_earnings')}
                </CaptionText>
                <H2 bold mb='8'>
                  {backOffice &&
                    formatUSD(
                      NumberRound(backOffice?.user?.totalEarnings)
                    )}{' '}
                  {USDT}
                </H2>
                <P3 flex color={colors.neutral500}>
                  <P3 color={colors.secondary100} mr='5' bold>
                    +
                    {backOffice &&
                      formatUSD(
                        NumberRound(backOffice?.user?.currentWeekEarnings)
                      )}{' '}
                    {USDT}{' '}
                  </P3>
                  {t('earnings.this_week')}
                </P3>
              </div>
            </Flex>
          </Mobile>
        </div>
      </Box>

      {!wide && (
        <Box>
          <div onClick={() => history.push(EARNINGS)}>
            <CaptionText mb='4' color={colors.neutral500}>
              {USDT} {t('earnings.balance')}
            </CaptionText>
            <H4 mb='20'>
              {formatUSD(backOffice?.user?.userTickets?.availableRewardPoints)}{' '}
              {USDT}
            </H4>
          </div>

          <div onClick={() => history.push(EARNINGS)}>
            <CaptionText mb='4' color={colors.neutral500}>
              {t('earnings.club_balance')}
            </CaptionText>
            <H4 mb='20'>
              {formatUSD(backOffice?.user?.userTickets?.shoppingPoints)} {USDT}
            </H4>
          </div>

          {backOffice?.user?.userTickets?.loyaltyPoints &&
          backOffice?.user?.userTickets?.loyaltyPoints > 0 ? (
            <div onClick={() => history.push(EARNINGS)}>
              <CaptionText mb='4' color={colors.neutral500}>
                {t('earnings.loyalty_points')}
              </CaptionText>
              <H4 mb='20'>
                {formatUSD(backOffice?.user?.userTickets?.loyaltyPoints)} {LP}
              </H4>
            </div>
          ) : null}

          <HubInfo />
        </Box>
      )}
      {bonusesIcons.map((tip, i) => {
        return (
          <ReactTooltip
            key={i}
            id={tip.id}
            place='top'
            effect='solid'
            backgroundColor='#fff'
            textColor={colors.neutral900}>
            {tip.tip}
          </ReactTooltip>
        );
      })}
    </>
  );
};
